import { useState } from "react";
import { api, apiError } from "../lib/apiClient";
import { toast } from "sonner";
import { KeyRound, Eye, EyeOff, Loader2, ShieldCheck } from "lucide-react";

export function PasswordSecurity({ testid = "security-panel" }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [show, setShow] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next.length < 6) return setError("Le nouveau mot de passe doit faire au moins 6 caractères.");
    if (next !== confirm) return setError("Les deux mots de passe ne correspondent pas.");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      setCurrent(""); setNext(""); setConfirm("");
      toast.success("Mot de passe mis à jour");
    } catch (err) {
      const msg = apiError(err, "Changement impossible");
      setError(msg);
      toast.error(msg);
    } finally {
      setSaving(false);
    }
  };

  return (
    <section data-testid={testid} className="hud-panel reticle clip-corner p-5 sm:p-6">
      <span className="rc-tr" />
      <span className="rc-bl" />
      <div className="mb-4 flex items-center gap-2">
        <ShieldCheck className="h-4 w-4 accent-text" />
        <h3 className="font-mono-hud text-[10px] tracking-[0.25em] text-[#8b949e] uppercase">Sécurité — mot de passe</h3>
      </div>

      <form onSubmit={submit} className="grid gap-4 sm:grid-cols-3">
        <label className="block">
          <span className="font-mono-hud text-[10px] tracking-[0.2em] text-[#8b949e] block mb-1.5">MOT DE PASSE ACTUEL</span>
          <input
            data-testid="security-current-input"
            type={show ? "text" : "password"}
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
            autoComplete="current-password"
            required
            placeholder="••••••••"
            className="hud-input"
          />
        </label>
        <label className="block">
          <span className="font-mono-hud text-[10px] tracking-[0.2em] text-[#8b949e] block mb-1.5">NOUVEAU MOT DE PASSE</span>
          <input
            data-testid="security-new-input"
            type={show ? "text" : "password"}
            value={next}
            onChange={(e) => setNext(e.target.value)}
            autoComplete="new-password"
            required
            placeholder="6 caractères minimum"
            className="hud-input"
          />
        </label>
        <label className="block">
          <span className="font-mono-hud text-[10px] tracking-[0.2em] text-[#8b949e] block mb-1.5">CONFIRMATION</span>
          <input
            data-testid="security-confirm-input"
            type={show ? "text" : "password"}
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            autoComplete="new-password"
            required
            placeholder="Retape le nouveau"
            className="hud-input"
          />
        </label>

        {error && (
          <p data-testid="security-error" className="sm:col-span-3 font-mono-hud text-[11px] text-[#ff6b6b]">» {error}</p>
        )}

        <div className="sm:col-span-3 flex flex-col sm:flex-row sm:items-center gap-3">
          <button
            data-testid="security-submit-button"
            type="submit"
            disabled={saving}
            className="hud-btn clip-corner flex items-center justify-center gap-2 px-5 py-3 text-sm font-bold disabled:opacity-50"
          >
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <KeyRound className="h-4 w-4" />}
            {saving ? "MISE À JOUR..." : "CHANGER LE MOT DE PASSE"}
          </button>
          <button
            data-testid="security-toggle-visibility"
            type="button"
            onClick={() => setShow((v) => !v)}
            className="flex items-center gap-1.5 font-mono-hud text-[10px] uppercase tracking-[0.18em] text-[#8b949e] hover:text-white transition-colors"
          >
            {show ? <EyeOff className="h-3.5 w-3.5" /> : <Eye className="h-3.5 w-3.5" />}
            {show ? "Masquer" : "Afficher"}
          </button>
        </div>
      </form>
    </section>
  );
}
